export const DNI_JWT_TOKEN_KEY = 'dni_jwt_token'
export const BUTLER_JWT_TOKEN_KEY = 'butler_jwt_token'
export const COSIGN_X_PLATFORM_TOKEN = 'x_platform_token'
export const COSIGN_TOKEN_KEY = 'cosign_token'
export const MERCHANT_ACCESS_TOKEN_KEY = 'merchant_access_token'
export const USER_SELECTED_LANG_COOKIE = 'user_selected_lang'
